<template>
<div>
	<main class="main-wrapper flex-grow-1 with-footer">
		<div class="d-flex align-items-center bg-white">
			<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
					{{ $t("735") }}
			</div>
			<div class="mgr-24 right-button">
				<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" type="button"  @click="goBackToSurvey" @keypress="goBackToSurvey">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-color-iconActive font-r">{{$t('3318')}}</span>
				</button>
			</div> 
		</div>
		<div class="divider"></div>
			<transition name="slide">
				<component
					:is="questions[currentQuestionIndex].type.value"
					v-if="questions[currentQuestionIndex]"
					:key="questions[currentQuestionIndex].id"
					ref="questionComp"
					:eachViewFeedback="eachViewFeedback"
					:question="questions[currentQuestionIndex]"
				>
				</component>
		</transition>
	</main>
	<div class="footer bg-white bottomStack">
		<div class="divider"></div>
		<div class="container container--narrow pdt-6 pdb-6">
			<div v-if="!isFirstQuestion" class="d-flex align-items-center justify-content-between pdt-4 pdb-3">
					<div v-if="!isFirstQuestion" class="d-flex align-items-center">
					
						<button class="mdc-button t-color-secondaryBtnText mgr--12 mgl--12" 
						tabindex="0" @click="prevQuestion()" @keypress="prevQuestion()">
								<div class="mdc-button__ripple"></div>
								<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_left</i>
								<span class="mdc-button__label t-body2 font-r">{{$t('711')}}</span>
						</button>
					</div>
						<div v-if="!isLastQuestion" class="d-flex align-items-center">
							<button class="mdc-button bg-secondary t-color-secondaryBtnText  mgr--12 mgl--12"
								tabindex="0" @click="nextQuestion()" @keypress="nextQuestion()">
									<div class="mdc-button__ripple"></div>
									<span class="mdc-button__label t-body2 font-r">{{ $t("712") }}</span>
									<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_right</i>
							</button>
							
						</div>
					<div v-if="isLastQuestion" class="d-flex align-items-center">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr--12" tabindex="0" @click="moveSurveyView()" @keypress="moveSurveyView()">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r t-nowrap">{{ $t("745") }}</span>
						</button>
				</div>
			</div>
			<div v-if="isFirstQuestion && !isLastQuestion" class="d-flex align-items-center justify-content-end pdt-4 pdb-3">
				<div class="d-flex align-items-center">
					<button class="mdc-button bg-secondary t-color-secondaryBtnText mgr--12 mgl--12" tabindex="0" @click="nextQuestion()" @keypress="nextQuestion()">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('712')}}</span>
							<i aria-hidden="true" class="material-icons mdc-button__icon">chevron_right</i>
					</button>
				
				</div>
			</div>
		 <div v-if="isLastQuestion && isFirstQuestion" class="d-flex align-items-center justify-content-end pdt-4 pdb-3">
				<div class="d-flex align-items-center">
					<button class="mdc-button bg-secondary bg-mainBtn t-color-mainBtnText b-radius4 " tabindex="0" @click="moveSurveyView()" @keypress="moveSurveyView()">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('745')}}</span>
					</button>
				</div>
			</div> 
	</div>
</div>
</div>
</template>

<script>
/**
 * 설문 피드백 메인 컴포넌트(survey feedback main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";
import {MDCRipple} from '@material/ripple'

export default {
	name: "surveyFeedback",
	components: {
		SHORT_ANSWER: () => import("./question/ShortAnswerFeedback.vue"),
		CHOICE_SINGLE: () => import("./question/ChoiceSingleFeedback.vue"),
		CHOICE_MULTIPLE: () => import("./question/ChoiceMultipleFeedback.vue"),
		STARS: () => import("./question/StarsFeedback.vue"),
		RANKING: () => import("./question/RankingFeedback.vue"),
	},

	mixins: [surveyMixin],

	data() {
		return {
			questions: [],
			currentQuestionIndex: 0,
			eachViewFeedback: false,
      isMicro: this.$route.query.isMicro === true
		};
	},

	created() {
		this.fatchData();
	},

	computed: {
		// is first question
		isFirstQuestion() {
      return this.currentQuestionIndex === 0;
		},

		// is last question
		isLastQuestion() {
			return this.currentQuestionIndex === this.questions.length - 1;
		},
	},

	mounted() {
    if(this.isMicro) {
      this.routePath = '/learn/';
    } else {
      this.routePath = '/micro/';
    }
    this.setMaterialUi();
  },

	methods: {
		setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
        let button = new MDCRipple.attachTo(el)
        return button;
      })
    },

		fatchData() {
			let params = {
				respondentId: this.$route.params.respondentId,
				distId: this.$route.params.distId,
			};

			// get survey respondent feedback
			surveyApi.surveyRespondentFeedback(params).then((response) => {
				this.feedbackData = response.data.data;
				this.eachViewFeedback = this.feedbackData.eachViewFeedback;
				let number = 1;

				// set question list
				_.each(this.feedbackData.groups, (group, groupIndex) => {
					_.each(group.questions, (question, questionIndex) => {
						question.essential = group.essential;
						question.number = number++;

						this.questions.push(question);
					});
				});
			});
		},

		// move next question
		nextQuestion() {
			this.currentQuestionIndex++;
		},

		// move prev question
		prevQuestion() {
			this.currentQuestionIndex--;
		},

		goBackToSurvey() {
			if (this.$route.query.distributionType === "SATISFACTION") {
				this.$router.push(
            this.routePath +
						this.$route.query.learnId +
						"?status=" +
						this.$route.query.status +
						"&tab=viewSurvey"
				);
			} else {
				this.$router.push({
					name: "IndependentSurveyTotalView",
					params: { distId: this.$route.params.distId },
					query: this.$route.query,
				});
			}
		},
	},
};
</script>